import { HOOKS_CLICK_TOLERANCE } from '../constants';
import { useEffect, useRef } from 'react';
import { useNodeRef } from './useNodeRef';
import { useFunction } from './useFunction';
import { useVariable } from './useVariable';
export var usePreventDrag = function usePreventDrag(initialRef, disabled, disabledUserSelect, tolerance) {
  if (disabled === void 0) {
    disabled = false;
  }

  if (disabledUserSelect === void 0) {
    disabledUserSelect = false;
  }

  if (tolerance === void 0) {
    tolerance = HOOKS_CLICK_TOLERANCE;
  }

  var mouseMoved = useRef(false);
  var downEvent = useRef(null);
  var onDragStart = useVariable(function (e) {
    if (disabled || !e) {
      return;
    }

    e.preventDefault();
  });
  var onMouseMove = useFunction(function (e) {
    if (disabled || !e || !downEvent.current) {
      return;
    }

    var mouseDragMoved = Math.abs(e.pageX - downEvent.current.pageX) >= tolerance || Math.abs(e.pageY - downEvent.current.pageY) >= tolerance;

    if (mouseDragMoved) {
      if (!disabledUserSelect) {
        var _window$getSelection;

        window.getSelection == null ? void 0 : (_window$getSelection = window.getSelection()) == null ? void 0 : _window$getSelection.selectAllChildren == null ? void 0 : _window$getSelection.selectAllChildren(nodeRef.current);
      }

      mouseMoved.current = true;
    }
  });
  var unbindRef = useRef(null);

  var bind = function bind() {
    var unbind = function unbind() {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseleave', unbind);
      window.removeEventListener('mouseup', unbind);
      window.removeEventListener('dragend', unbind);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseleave', unbind);
    window.addEventListener('mouseup', unbind);
    window.addEventListener('dragend', unbind);
    return unbind;
  };

  var onMouseDown = useVariable(function (e) {
    if (disabled || !e) {
      return;
    }

    mouseMoved.current = false;
    downEvent.current = e;
    unbindRef.current = bind();
  });
  var onClick = useVariable(function (e) {
    if (disabled || !e || !downEvent.current) {
      return;
    }

    var mouseClickMoved = Math.abs(e.pageX - downEvent.current.pageX) >= tolerance || Math.abs(e.pageY - downEvent.current.pageY) >= tolerance;

    if (mouseMoved.current || mouseClickMoved) {
      e.preventDefault();
    }

    unbindRef.current == null ? void 0 : unbindRef.current();
  });
  useEffect(function () {
    return function () {
      return unbindRef.current == null ? void 0 : unbindRef.current();
    };
  }, []);

  var _useNodeRef = useNodeRef(initialRef, function (node) {
    node.addEventListener('click', function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return onClick.current == null ? void 0 : onClick.current.apply(onClick, args);
    }, {
      capture: true
    });
    node.addEventListener('mousedown', function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return onMouseDown.current == null ? void 0 : onMouseDown.current.apply(onMouseDown, args);
    });
    node.addEventListener('dragstart', function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return onDragStart.current == null ? void 0 : onDragStart.current.apply(onDragStart, args);
    });
  }),
      setRef = _useNodeRef[0],
      nodeRef = _useNodeRef[1];

  return {
    nodeRef: nodeRef,
    setRef: setRef
  };
};